<template>
  <section
    :class="{ 'modal-ceu__show': showModal }"
    class="modal-ceu modal-edit">
    <div
      @click="closeModal"
      class="modal-ceu__overley"/>
    <div class="modal-ceu__content coupon__modal medium">
      <div v-if="!uploading">
        <div
            @click="closeModal"
            class="modal-ceu__close">
          <i class="ceu-icon-close" />
        </div>

        <form @submit.prevent = "uploadFile">	      
          <div class="menu-restaurant__add-title ceu-container2">       
            <div class="ceu-campo__text-round3 ceu-item s-50">
              <p>Archivo</p>
              <input type='file' @change="setFile"/>
            </div>
          </div>
          <div class="ceu-campo__text-round3 ceu-item s-100">
            <div
                @click="$emit('toggle-modal')"
                class="ceu-btn2 black">
              Cancelar
            </div>
            <button v-if="file"
                type="submit"
                class="ceu-btn1">
              Subir Archivo
            </button>
          </div>
        </form>
      </div>
      <div v-else>
       <div>Subiendo archivo...</div> 
      </div>
    </div>
  </section>
</template>

<script>
import configService from '../../settings/api-url'
export default {
  data () {
    return {
      file: null,
      uploading: false
    }
  },
  watch: {
    data (newValue, oldValue) {
	console.log('hi from modal')	
    }
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setFile (value) {
      let file = value.target.files[0]
      let reader =  new FileReader()
      reader.onloadend = (loadedEvent) => {
        this.file = loadedEvent.target.result
      }
      reader.readAsDataURL(file) 
    },
    async reset () {
      const data_coming = await configService.delete(`admin/row_materials/${this.data.id}`)
      this.$emit('reset', data_coming.data)
      this.$emit('toggle-modal')
    },
    async sendCategoryName () {
      try {
        const data = {
          category_row_material: {
            name: this.categoryName
          }
        }
        const data_coming = await configService.post('admin/category_row_materials', data)
        this.$emit('toggle-modal')
        this.$emit('push-category', data_coming.data)
      } catch (error) {
        console.log(error)
      }
    },
    closeModal () {
      this.$emit('toggle-modal')
    },
    async uploadFile () {
      const data = { file: this.file.split(',')[1] }
      try {
        this.uploading = true
        await configService.post('admin/upload_files', data)
        this.uploading= false
        this.$swal({
          position: 'center',
          type: 'success',
          title: 'Archivo subido',
          showConfirmButton: false,
          timer: 1500
        })
        this.$emit('toggle-modal')

      } catch (error) {
        console.log(error)
      }
     
    }
  }
}
</script>

<style>

</style>
